import script from "./SolutionDetail.vue?vue&type=script&setup=true&lang=js"
export * from "./SolutionDetail.vue?vue&type=script&setup=true&lang=js"

import "./SolutionDetail.vue?vue&type=style&index=0&id=69bac3e0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-69bac3e0"]])

export default __exports__